import React from "react";

const Chips = ({ items = [], amountToShow, onClickChip, onClickShowMore }) => {
  const chips = amountToShow ? items.slice(0, amountToShow) : items;
  // console.log("items: ", items);
  return (
    <>
      {chips.map((item, index) => {
        return (
          <div
            key={index + "-" + item}
            className="order-history-invoice-chip"
            onClick={() => {
              onClickChip(item);
            }}
          >
            {item}
          </div>
        );
      })}
      {items.length > amountToShow && (
        <div className="order-history-invoice-chip" onClick={onClickShowMore}>
          + {items.length - amountToShow} more
        </div>
      )}
    </>
  );
};

export default Chips;
